module.exports = __webpack_public_path__ + "images/emoji/black_medium_small_square.46c8d86032544debf4fb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_medium_small_square.png
// module id = LZ1U
// module chunks = 14